import store from '../../store'
import { settings } from '@/api'
import { checkSetting, getCachedSettings } from '../../utils/helpers'
import { SETTINGS_URL_GET } from '../../store/settings/types'
import tokenService from '../../services/token.service'
import { uuid } from 'vue-uuid';

async function authCheck() {

	async function getSettingsUrl() {
		if (!store.state.settings.url) {
			let data
			const cachedUrl = checkSetting('url')
			if (!cachedUrl) {
				const response = await settings.getSettingsUrl()
				data = response.data
				localStorage.setItem('settings', JSON.stringify(
					{
						...JSON.parse(localStorage.getItem('settings')),
						url: {
							value: data.url,
							expiryIn: new Date().getTime() + 1000 * 60 * 5
						}
					}
				))
			}
			store.commit(`settings/${SETTINGS_URL_GET}`, cachedUrl || data.url)
		}
	}
	await getSettingsUrl()
	return new Promise((resolve) => {
		if (!store.getters['auth/isChecked']) {

			const unwatch = store.watch(
				() => store.getters['auth/isChecked'],
				() => {
					unwatch()
					resolve(store.getters['auth/isAuthenticated'])
				}
			)
			
			store.dispatch('auth/getProfile')

			getCachedSettings(store)
		} else {
			resolve(store.getters['auth/isAuthenticated'])
		}
	})
}

export default async (to, from, next) => {
	if (!tokenService.getDeviceIdFromStorage()) {
		tokenService.setDeviceIdToStorage(uuid.v4())
	}
	
	await authCheck()
	next()
}
